import { Route, Routes } from 'react-router-dom';

import IntelligenceLayout from '../components/intelligence/IntelligenceLayout.jsx';
import SubtabIndexRedirect from '../components/SubtabIndexRedirect.jsx';
import { DEFAULT_INTELLIGENCE_SUBTAB } from '../constants/intelligence.js';
import InsightsPage from './InsightsPage.jsx';
import TraitsPage from './TraitsPage.jsx';

/**
 * The Intelligence tab of a profile (CT-5715): Traits and Insights, as CHILD
 * ROUTES of the tab (`intelligence/traits`, `intelligence/insights`), so a
 * subtab survives a reload, a pasted link and Back.
 *
 * It is a tab KIND (`TAB_KINDS.INTELLIGENCE`) registered in `ProfileTabPage`;
 * the tabs endpoint decides which entity types get it, so nothing here is keyed
 * by type. The profile route is `:tabId/*` for exactly this.
 *
 * The layout route is pathless: it only hands the subtab switch down. Under
 * `v7_relativeSplatPath` a relative link resolves against the splat route's
 * FULL path, so the index redirect works (the splat is empty there) but the
 * switch builds absolute targets — see `IntelligenceLayout`.
 */
function IntelligenceTabPage() {
  return (
    <Routes>
      <Route element={<IntelligenceLayout />}>
        <Route index element={<SubtabIndexRedirect to={DEFAULT_INTELLIGENCE_SUBTAB} />} />
        <Route path="traits" element={<TraitsPage />} />
        <Route path="insights" element={<InsightsPage />} />
      </Route>
    </Routes>
  );
}

export default IntelligenceTabPage;
